__turbopack_context__.v({
  "container": "SP8uuG_container",
  "isActive": "SP8uuG_isActive",
  "isDimmed": "SP8uuG_isDimmed",
  "item": "SP8uuG_item",
  "label": "SP8uuG_label",
  "swatch": "SP8uuG_swatch",
  "value": "SP8uuG_value",
});
